import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ThemeService, UtilityService } from '../../../services';
import { AuthStateService } from '../../../services/global/auth-state.service';
import { MatDialog } from '@angular/material/dialog';
import { AuthComponent } from '../../auth/auth.component';
import { AUTH_PROFILE } from '../../constants/navigation';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { GlobalFlightInfoService } from '../../../services';

import { BrokenImageUrlPipe } from '../../../pipe/broken-image-url.pipe';

@Component({
  selector: 'app-sidebar',
  imports: [CommonModule, MatIconModule, MatButtonModule, RouterLink, RouterLinkActive, BrokenImageUrlPipe],
  templateUrl: './sidebar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  @Output() closeSidebar = new EventEmitter<void>();
  public theme = inject(ThemeService);
  public authState = inject(AuthStateService);
  public util = inject(UtilityService);
  public globalWebsite = inject(GlobalFlightInfoService);
  readonly dialog = inject(MatDialog);
  imageError = false;
  authProfile = AUTH_PROFILE;
  WEBSITE_INFO: any;

  ngOnInit() {
    this.globalWebsite.WEBSITE_INFO().subscribe({
      next: (data) => {
        this.WEBSITE_INFO = data?.data;
      }
    });
    this.authState.user$.subscribe(() => {
      this.imageError = false;
    });
  }

  handleImageError() {
    this.imageError = true;
  }

  getInitials(name?: string): string {
    if (!name) return '';
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  }

  authSetting() {
    this.closeSidebar.emit();
    const dialogRefAuth = this.dialog.open(AuthComponent, {
      panelClass: 'authDialogClass',
      maxWidth: '90vw'
    });
    dialogRefAuth.afterClosed().subscribe(result => {
      if (result === 'login-success') {
        dialogRefAuth.close();
      }
    });
  }

  logout() {
    this.authState.logout();
    this.closeSidebar.emit();
  }
}
